import {
  PageSubContainerSkeleton,
  TableSkeleton,
  ToolbarSkeleton,
} from "@project/components/feedback";
import {offerTemplateNotesRouteApi} from "../-route-api";

export function OfferTemplateNotesPending() {
  const search = offerTemplateNotesRouteApi.useSearch();
  return (
    <PageSubContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
        </div>
        <ToolbarSkeleton.Actions className="hidden @lg:flex">
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>
      <TableSkeleton columns={4} rows={search.perPage ?? 10} />
    </PageSubContainerSkeleton>
  );
}
